import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { apiUrl } from "../../../services/constants";
import { GET_ACCESSOTIRES } from "../../../services/graphql-query";
import { Row, Col } from 'react-bootstrap';

const Accessories = (props) => {

    const { spec } = props;
    const category = window.localStorage.getItem("category");
    const collection = window.localStorage.getItem("product_name");

    const { data } = useQuery(GET_ACCESSOTIRES, { variables: { category: category, collection, collection } });

    let accessoiredData = [];
    if (data) {
        accessoiredData = data.accessories.data;
    }

    return (
        <React.Fragment>
            <div className="mobile-hide">
                {
                    accessoiredData.length !== 0 ? accessoiredData.map((item, key) => (
                        <Row className="mt-5 mb-5" key={key}>
                            <Col md={2}>
                                <img src={apiUrl + item?.attributes?.Image?.data[0]?.attributes?.url} alt="accessoires" width="100%" height="200px"></img>
                            </Col>
                            <Col md={10} className="pl-5 accessories-items">
                                <div>
                                    <h4>{item?.attributes?.Name}({item?.attributes?.Abreviation})</h4>
                                    <p>{item?.attributes?.category?.data?.attributes?.name}</p>
                                </div>
                                <div><a className="d-flex spec-button mr-4 flex-wrap" href={apiUrl + spec?.attributes?.url} target="_blank">VIEW SPEC SHEET</a></div>
                            </Col>
                        </Row>
                    )) : <p className="empty-data">No data</p>
                }
            </div>
            <div className="mobile-show">
                {
                    accessoiredData.length !== 0 ? accessoiredData.map((item, key) => (
                        <div className="mt-5 mb-5 pl-5 pr-5" key={key}>
                            <img src={apiUrl + item?.attributes?.Image?.data[0]?.attributes?.url} alt="accessoires" width="100%" height="200px"></img>
                            <div className="d-flex justify-content-between accessoires-list mt-2">
                                <p>{item?.attributes?.Name}({item?.attributes?.Abreviation})</p>
                                <p className="accessories-name">{item?.attributes?.category?.data?.attributes?.name}</p>
                            </div>
                        </div>
                    )) : <p className="empty-data">No data</p>
                }
            </div>
        </React.Fragment>
    )
}

export default Accessories;